<template>
	<div class="homePage">
		<div class="section">
    <div class="crumbs">
		<router-link to="/index/homePage" class="router-link-active">首页<i>&gt;</i></router-link>
        <router-link to="/index/mybaojia"  class="">我的报价<i>&gt;</i></router-link>
   		 <span id="bread">我的报价详情</span>
    </div>
</div>

<div class="bid-info-bar shadow section">
  <div class="biddfo-top">
       <h2 id="bidTitle">{{ title }}</h2>
       <h6 class="info-number"><i class="iconfont icon-shijian"></i> 公告日期：{{ bdate }}</h6>
    
  </div>
  
  <div class="company-info-bar">
     <div class="company-info-content clearfix">
     

       <strong>招标详情介绍</strong>：<br>
	   <div v-html="content"></div>
      <div class="wodess">

               <div class="woflex">
               	<div class="wof1">付款金额：</div>
               	<div class="wof2"><p class="sucolor2">{{ pay_amount }}</p></div>
               </div>

			   <div class="woflex">
               	<div class="wof1">付款方式：</div>
               	<div class="wof2"><p class="sucolor2">{{ pay_way }}</p></div>
               </div>

			   <div class="woflex">
               	<div class="wof1">联系人：</div>
               	<div class="wof2"><p class="sucolor2">{{ contact }}</p></div>
               </div>

			   <div class="woflex">
               	<div class="wof1">联系电话：</div>
               	<div class="wof2"><p class="sucolor2">{{ mobile }}</p></div>
               </div>
               
            
               
               <div class="woflex">
               	<div class="wof1">是否中标：</div>
               	<div class="wof2">
						<p v-if="baostatus == -1" class="sucolor3"><i class="iconfont icon-dengdai"></i> 竞标中</p>
                		<p v-else-if="baostatus == 1" class="sucolor1"><i class="iconfont icon-queren"></i> 已中标</p>
						<p v-else-if="baostatus == 2" class="sucolor3"><i class="iconfont icon-dengdai"></i> 还价中</p>
                        <p v-else class="sucolor2"><i class="iconfont icon-guanbi"></i> 未中标</p>
						
                </div>
               </div>
               
                <div class="woflex">
               	<div class="wof1">投标日期：</div>
               	<div class="wof2">{{ baocreate_time }}</div>
               </div>
               

			   <div class="woflex">
               	<div class="wof1">上传的文件：</div>
               	<div class="wof2"><a :href="fileurl" target="_blank"  class="downbiaoshu">点击查看</a></div>
               </div>
               
            </div>
			
			<router-link  to="/"  class="boajia" style="margin-top: 0;">查看其他招标信息</router-link>
			

     </div>
  </div>
  
 


</div>
<!-- <div class="xiugaidizhi" v-if="xiugaist == true">
                <div class="dizhi">
            
                  <div class="secad">
                    <input placeholder="请重新输入价格" v-model="toutitle" />
                  </div>
				  <div style="padding-top:10px;">
					<textarea
						rows="4"
						class="hmyinput"
						placeholder="请输入您的报价详情（选填）" v-model="toucontent"
						></textarea>
                  </div>
                  <div class="xinzeng">
                    <div class="xinzeng1"  @click="open" >
                      确定
                    </div>
                    <div class="xinzeng2" @click="quxiao" >
                      取消
                    </div>
                  </div>
                </div>

              </div> -->
			
	</div>
</template>

<script>
	export default {
		name: "mydetail",
		components: {},
		data() {
			return {
				title: '',
				content:'',
				bdate: '',
				commentId:'',
				baojia:'',
				 baocontent:'',
				 baocreate_time:'',
				 baostatus:'',
				 xiugaist: false,
				 toutitle:'',
				 fileurl:'',

				 pay_amount:'',
				 pay_way:'',
				 contact:'',
				 mobile:'',
      			 toucontent:''
			};
		},
		created() {
			
		},
		mounted() {
			this.getreqWtInfo(this.$route.query.commentId);
			this.commentId = this.$route.query.commentId;
			
		},
		methods: {
			async getreqWtInfo(commentId) {
			let res = await this.req.reqWtInfo({
				commentId,
			});
			console.log(res);
			if (res.status == 200) {
				let articleinfo = res.data.detail;
				 this.content = articleinfo.article.content;
				 this.bdate = articleinfo.article.bdate;
				 this.title = articleinfo.article.title;
				 this.baojia = articleinfo.title;
				 this.baocontent = articleinfo.content;

				 this.pay_amount = articleinfo.pay_amount;
				 this.pay_way = articleinfo.pay_way;
				 this.contact = articleinfo.contact;
				 this.mobile = articleinfo.mobile;

				 this.baocreate_time = articleinfo.create_time;
				 this.baostatus = articleinfo.status;
				 this.fileurl = articleinfo.images[0].image_url;				 

			} else {
				this.$message.error(res.message);
			}
			},


			async chongxin() {	
					this.xiugaist = true
			},
			//取消弹出框
			quxiao() {
				this.xiugaist = false
			},

			   // 重新投标
			   async chongxintoubiao(){
				var that = this;
				var form = {
					title:this.toutitle,
					content:this.toucontent,
				};
				let res = await this.req.cctoubiao({
					comment_id:this.commentId,
					form
				});
				if(res.status == 200){
					this.xiugaist = false
					this.$message.success(res.message);
					setTimeout(function(){
						that.$router.push("/index/mybaojia");
					},1000)
				}else{
					this.$message.error(res.message);
					this.xiugaist = false
				}
			},
			//投标提示
			open() {  
            let that = this;
            if (!this.toutitle.trim()) {
               this.$message.error('报价不能为空');
               return
            }

            this.$confirm('此操作将对此标书进行重新报价, 是否继续?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            }).then(() => {
               that.chongxintoubiao()
            }).catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               });          
            });
         }
			
		},
	};
</script>

<style lang="less" scoped>
	.xiugaidizhi {
		width: 100%;
		height: 100vh;
		position: fixed;
		z-index: 10;
		left: 0;
		top: 0;
		box-sizing: border-box;
		padding: 25px;
		background-color: rgba(0, 0, 0, 0.3);
		display: flex;
		align-items: center;

		.dizhi {
			width: 600px;
			background-color: #fff;
			box-sizing: border-box;
			padding: 25px;
			border-radius: 8px;margin: 0 auto;text-align: center;

			.secad1 {
				color: #000;
				font-size: 16px;
				font-weight: bold;
				padding-bottom: 8px;
			}

			.secad {
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-sizing: border-box;
				color: #858585;
				font-size: 14px;
				line-height: 50px;
				height: 50px;
				border-bottom: 1px solid #f9f9f9;
			}

			.secad input {
				width: 100%;
				font-size: 14px;
				border: 1px solid #e8e8e8;
  padding: 10px 15px;
			}

			.xinzeng {
				padding: 25px 0 10px 0;
				width: 100%;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			.xinzeng1 {
				height: 40px;
				width: 45%;
				line-height: 40px;
				background: linear-gradient(to right, #fd0402, #fe7879);
				text-align: center;
				color: #fff;
				font-size: 16px;
				border-radius: 5px;
			}

			.xinzeng2 {
				height: 40px;
				width: 45%;
				line-height: 40px;
				background-color: #929292;
				text-align: center;
				color: #fff;
				font-size: 16px;
				border-radius: 5px;
			}

		}
	}
	
</style>
